// NPM Imports
import React from "react";

// Chart Imports
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import ReactFC from "react-fusioncharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Internal Imports
import { DASHBOARD } from "../../../../constants";

// Destructuring
const { BAR_CHART_CONFIGS } = DASHBOARD;

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

/**
 * :: BarChart ::
 * (for showing the data in bar chart format with chart type 'bar2d'),
 *  - uses const 'BAR_CHART_CONFIGS' which includes the base configurations for chart
 *  - need to pass the followings props,
 *    1. 'chart'   - chart related configs
 *    2. 'data'    - array of objects
 *    3. 'width'   - chart container width
 *    4. 'height'  - chart container height
 *  - for more details 'https://www.fusioncharts.com/dev/chart-attributes/bar2d'
 */

const BarChart = props => {
  const {
    configs: { chart, data, width, height },
  } = props;

  const getChartConfigs = () => {
    const chartConfigs = JSON.parse(JSON.stringify(BAR_CHART_CONFIGS));
    chartConfigs.width = width;
    chartConfigs.height = height;
    chartConfigs.dataSource = {
      ...chartConfigs.dataSource,
      chart: {
        ...chartConfigs.dataSource.chart,
        ...chart,
      },
      data,
    };
    return chartConfigs;
  };

  console.debug("Rendring the BarChart....");

  return <ReactFC {...getChartConfigs()} />;
};

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/Charts/BarChart/index.js